import { render, staticRenderFns } from "./NbHelpText.vue?vue&type=template&id=19500864&"
import script from "./NbHelpText.vue?vue&type=script&lang=js&"
export * from "./NbHelpText.vue?vue&type=script&lang=js&"
import style0 from "./NbHelpText.vue?vue&type=style&index=0&id=19500864&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports